<template>
    <div>
        <report-header
            :title="title"
            :isShowDateRange="true"
            :formatDateRangeTitle="dateRange"
        />
        <b-card id="report-card">
            <loader-barchart
                v-if="isLoading"
                class="graph-overlay"
                style="height: 430px; margin: 1em 0 2em 10px;"
                :styles="'height: 400px'"
            />
            <div
                id="average-client-transaction-chart"
                style="height: 400px; margin: 3em 0 2em 10px;"
            ></div>
        </b-card>
    </div>
</template>
<script>
import "@/jquery/jquery.flot.tooltip";
import "@/jquery/jquery.flot.axislabels";
import "@/css/quasar-table.css";
import Report from "@/mixins/report.js";
import ReportService from "@/services/report";
import CREPORT from "@/constants/report";
import { forEach } from "lodash";

export default {
    mixins: [Report],
    components: {
        LoaderBarchart: () => import("@/components/elements/loader-barchart"),
        ReportHeader: () => import("@/components/report/report-header")
    },
    props: {
        data: {
            type: Object,
            default() {
                return {
                    start: this.getInitalMonthChart(),
                    end: this.getEndDate("month"),
                    datePickerOptions: {
                        format: this.datepickerMonthFormat
                    }
                };
            }
        }
    },
    data() {
        return {
            isLoading: true,
            isError: false,
            dateRange: "",
            title: "Average Client Transaction",
            options: {}
        };
    },
    async mounted() {
        let self = this;
        self.data.isShowDateRange = true;
        self.data.exportOptionCsvOnly = true;
        self.data.datePickerOptions.format = self.datepickerMonthFormat;
        self.data.isFilterDateMonthOnly = true;
        self.data.datePickerOptionDefault = 1;

        self._getSetting().then(() => {
            self.data.start = self.getInitalMonthChart();
            self.data.end = self.getEndDate("month");
            self.data.from = self.converToUnix(self.data.start);
            self.data.to = self.converToUnix(self.data.end);
            self.init();
        });

        self.$root.$on("report-filter-date-range:refresh", this.init);
    },
    beforeDestroy: function () {
        this.data.datePickerOptions.format = this.getDateFormat();
        this.data.isFilterDateMonthOnly = false;
        this.data.datePickerOptionDefault = null;
        this.data.exportOptionCsvOnly = false;
        this.$root.$off("report-filter-date-range:refresh", this.init);
    },
    methods: {
        async init(params) {
            let self = this;
            self.isLoading = true;
            self.isError = false;

            if (params) {
                self.data.from = params.from;
                self.data.to = params.to;
            }
            self.dateRange = self.getDateRange(
                self.data.from,
                self.data.to,
                self.formatInMonth
            );
            await ReportService.getReport(
                CREPORT.TYPE.AVERAGE_CLIENT_TRANSACTION,
                {
                    from: self.data.from,
                    to: self.data.to
                }
            )
                .then(res => {
                    if (res && res.message && res.message.code === 200) {
                        self.dynamicPageTitle(self.title);
                        self.renderGraph(res.resource.results.detail_data);
                        self.dateRange = self.getDateRange(
                            res.resource.start_date,
                            res.resource.end_date,
                            self.formatInMonth
                        );
                    } else {
                        throw new Error("Error: Unable to get the report.");
                    }
                })
                .catch(e => {
                    console.error(e);
                    self.isLoading = false;
                    self.isError = true;
                    self.renderGraph({ Month: null });
                    self._message("Error: Unable to get the report", "danger");
                })
                .finally(() => {
                    self.isLoading = false;
                });
        },
        renderGraph(results) {
            let self = this;
            let xaxis = [];
            let xaxisLabel = [];

            let index = 1;
            forEach(results, (total, month) => {
                xaxisLabel.push([index, month]);
                xaxis.push([index, total]);
                ++index;
            });

            let data = [
                {
                    label: "Average Transaction Amount",
                    data: xaxis
                }
            ];

            self.options = {
                series: {
                    lines: {
                        show: true,
                        fill: true,
                        align: "center",
                        barWidth: 0.9
                    },
                    points: { show: true }
                },
                grid: {
                    borderWidth: 0,
                    hoverable: true
                },
                xaxis: {
                    ticks: xaxisLabel
                },
                yaxis: {
                    axisLabel: "(" + self._currency + ")",
                    axisLabelUseCanvas: false,
                    tickDecimals: 2,
                    tickFormatter: function numberWithCommas(x) {
                        return x
                            .toString()
                            .replace(/\B(?=(?:\d{3})+(?!\d))/g, ",");
                    }
                },
                tooltip: true,
                tooltipOpts: {
                    content: "%y.4",
                    shifts: {
                        x: 20,
                        y: 0
                    },
                    defaultTheme: false
                }
            };
            $.plot($("#average-client-transaction-chart"), data, self.options);
            $(window).resize(function () {
                if (
                    self.$router.history.current.path ==
                    "/report/" + CREPORT.TYPE.AVERAGE_CLIENT_TRANSACTION
                ) {
                    $.plot(
                        $("#average-client-transaction-chart"),
                        data,
                        self.options
                    );
                }
            });
        }
    }
};
</script>
<style>
#flotTip {
    padding: 3px 5px;
    background-color: #fff;
    z-index: 100;
    z-index: 2;
    box-shadow: 0 0 10px #555;
    border: 0px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
}

.axisLabels {
    top: -20px;
    margin-right: -17px;
    color: #5d5d5d;
    font-size: 11px;
}

.graph-overlay {
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    z-index: 2;
    cursor: pointer;
}
</style>
